
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from '@/components/ui/button';
import { CheckCircledIcon } from "@radix-ui/react-icons";
import WelcomePopup from '@/components/WelcomePopup';

interface RegistrationSuccessProps {
  email: string;
  name: string;
  showWelcomePopup: boolean;
  setShowWelcomePopup: (show: boolean) => void;
}

const RegistrationSuccess = ({ 
  email, 
  name, 
  showWelcomePopup, 
  setShowWelcomePopup 
}: RegistrationSuccessProps) => {
  const navigate = useNavigate();
  
  // Function to manually redirect to login page with the verification success parameter
  const handleNavigateToLogin = () => {
    // Clean URL parameters before navigating
    window.history.replaceState({}, document.title, window.location.pathname);
    // Navigate to login with email verification success parameter
    navigate(`/login?emailVerification=success&email=${encodeURIComponent(email)}`);
  };
  
  return (
    <>
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CheckCircledIcon className="w-12 h-12 text-green-500 mx-auto mb-4" />
          <CardTitle className="text-2xl font-bold text-vegana-primary">
            ¡Registro Completado!
          </CardTitle>
          <CardDescription>
            Tu cuenta ha sido creada exitosamente
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Alert className="mb-6 bg-blue-50 border-blue-200">
            <AlertTitle className="text-blue-800">Verifica tu correo electrónico</AlertTitle>
            <AlertDescription className="text-blue-700">
              Te hemos enviado un email de confirmación a <strong>{email}</strong>. 
              Por favor, revisa tu bandeja de entrada (y carpeta de spam) y haz clic en el 
              enlace para activar tu cuenta.
            </AlertDescription>
          </Alert>
          <div className="text-center text-sm text-gray-600 mt-4">
            <p>Una vez que hayas verificado tu correo electrónico, podrás iniciar sesión.</p>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center flex-col gap-4">
          <Button 
            onClick={handleNavigateToLogin}
            variant="secondary"
            className="w-full"
          >
            Ir a iniciar sesión
          </Button>
          <p className="text-xs text-gray-500 text-center">
            Al iniciar sesión, te guiaremos a través de los primeros pasos para 
            aprovechar al máximo Guía Vegana.
          </p>
        </CardFooter>
      </Card>
      <WelcomePopup 
        open={showWelcomePopup} 
        onOpenChange={setShowWelcomePopup} 
        username={name}
      />
    </>
  );
};

export default RegistrationSuccess;
